import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line no-restricted-syntax
import '@web/index.css';
// eslint-disable-next-line no-restricted-syntax
import '@web/sentryInit';
import App from '@web/App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(HelmetProvider, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }) }));
